import { render } from "./WorkspaceListPage.vue?vue&type=template&id=2d3fd308"
import script from "./WorkspaceListPage.vue?vue&type=script&lang=js"
export * from "./WorkspaceListPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__